<template>
  <div class="tableInfo">
    <div class="tableInfo-Table" v-for="(item, index) in tableInfo" :key="index">
      <div class="left">
        <el-avatar shape="square" :size="60" fit="fit" :src="item.headPortraits" />
        <div class="left-info">
          <div class="name">
            {{ item.name }}
            <span class="education" v-if="item.education">【{{ item.education }}】</span>
          </div>
          <div class="extra-info">
            {{ item.personType }}<span>{{ item.workingYears }}</span>
          </div>
          <div class="extra-info">
            <div>{{ item.personCountry }}{{ item.personProvince }}{{ item.personCity }}</div>
          </div>
        </div>
      </div>
      <div class="center">
        <el-timeline reverse class="timeline">
          <el-timeline-item v-for="(el, i) in item.personExperience" :key="i">
            <span class="time">{{ el.inductionTime }}- {{ el.quitTime }}</span>
            <span class="info">{{ el.companyName }}</span>
            <span class="info">{{ el.position }}</span>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div class="right">
        <slot :childInfo="item"></slot>
        <slot :childInfo="item" name="controlBtn"></slot>
        <div class="info source">信息来源：{{ item.source }}</div>
        <div class="info">最近更新时间：{{ item.updateTime }}</div>
      </div>
    </div>
    <el-pagination
      class="talent-page"
      :current-page="queryInfo.baseParam.pageNum"
      :page-sizes="[30, 50, 100]"
      :page-size="queryInfo.baseParam.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  props: {
    tableInfo: {
      type: Array,
      required: true
    },
    queryInfo: {
      type: Object,
      default: () => {}
    },
    total: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('handleSizeChange', val)
    },
    handleCurrentChange(val) {
      this.$emit('handleCurrentChange', val)
    }
  }
}
</script>

<style lang="less" scoped>
.tableInfo {
  .tableInfo-Table {
    background: #fff;
    padding: 15px 20px;
    display: flex;

    align-items: center;
    margin-bottom: 15px;
    .left {
      width: 200px;
      display: flex;
      .left-info {
        margin-left: 12px;
        .name {
          font-size: 18px;
          .education {
            font-size: 14px;
            color: #333333;
          }
        }
        .extra-info {
          font-size: 12px;
          color: #333333;
          padding: 2px 0;
        }
      }
    }
    .center {
      margin-top: 10px;
      flex: 1;
      padding: 0 40px;
      box-sizing: border-box;
    }
    .right {
      width: 350px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .btn-control {
        display: flex;
        margin-bottom: 4px;
      }
      .info {
        font-size: 12px;
        color: #999999;
        padding: 2px 0;
      }
      .source {
        margin-bottom: 4px;
      }
    }
    /deep/ .el-timeline-item:last-child {
      padding-bottom: 0;
    }
  }
  .talent-page {
    padding-bottom: 14px;
    text-align: right;
  }
}
</style>
